export const CANVAS_DATA = {
  PIXEL_SIZE: 10,
  CANVAS_WIDTH: 1000,
  CANVAS_HEIGHT: 1000,
  DRAG_THRESHOLD: 5,
  MIN_SCALE: 0.2,
  MAX_SCALE: 5,
};

export const PALETTE_COLORS = [
  "#000000",
  "#8B0000",
  "#A52A2A",
  "#B22222",
  "#DC143C",
  "#FF0000",
  "#FF4500",
  "#FF6347",
  "#FF7F50",
  "#FFA500",
  "#FFB300",
  "#FFC107",
  "#FFD700",
  "#FFEB3B",
  "#F0E68C",
  "#FFE4B5",
  "#F5DEB3",
  "#654321",
  "#8B4513",
  "#A0522D",
  "#CD853F",
  "#D2691E",
  "#DEB887",
  "#F4A460",
  "#D2B48C",
  "#BC8F8F",
  "#FF69B4",
  "#FF1493",
  "#FFC0CB",
  "#FFB6C1",
  "#E9967A",
  "#FA8072",
  "#F08080",
  "#006400",
  "#228B22",
  "#2E8B57",
  "#3CB371",
  "#556B2F",
  "#6B8E23",
  "#32CD32",
  "#00FF00",
  "#7FFF00",
  "#90EE90",
  "#98FB98",
  "#8FBC8F",
  "#008B8B",
  "#00CED1",
  "#20B2AA",
  "#40E0D0",
  "#00FFFF",
  "#AFEEEE",
  "#B0E0E6",
  "#ADD8E6",
  "#87CEEB",
  "#87CEFA",
  "#1E90FF",
  "#4169E1",
  "#4682B4",
  "#5F9EA0",
  "#0000FF",
  "#191970",
  "#00008B",
  "#000080",
  "#4B0082",
  "#6A0DAD",
  "#8B008B",
  "#9370DB",
  "#9932CC",
  "#8A2BE2",
  "#BA55D3",
  "#DA70D6",
  "#DDA0DD",
  "#D8BFD8",
  "#E6E6FA",
  "#2F4F4F",
  "#696969",
  "#708090",
  "#778899",
  "#808080",
  "#A9A9A9",
  "#C0C0C0",
  "#D3D3D3",
  "#DCDCDC",
  "#F5F5F5",
  "#FFFFFF",
];
